import { object } from "firebase-functions/v1/storage";

// CLASSES
export class Appointment {
    cr: string | null = null;
    date: string = (new Date((new Date).getTime() - 4 * 60 * 60 * 1000)).toISOString().split('T')[0]; //  adjusts for timezone, string splits
    diagnosis: string = ''; 
    newDiagnosis: boolean = false;
    aptType: string = 'regular'; 
    time: string = ''; //(new Date()).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).slice(0, -2);
    length: number | null = 0;
    patientType: string = 'regular';
    // hasReferral: boolean = false; 
    wasAssessedForHospitalAdmission: boolean = false;
    billingTime: string | null = null; // defined as the instant user clicks submit
    userSubmittedCustomCodes: boolean = false; // in order to keep track of our accuracy
    seenAnotherDoctor: boolean = false;
    codes: Array<string> = [];
    price: number = 0;
    patientName: string | null = null;
    specialVisit: string  = "No";
    performedTravel: boolean = false;
    firstPersonSeen: boolean = false;
    sacrificeOfOfficeHours: boolean = false;
    electiveHomeVisit: boolean = false;
    isClinic: boolean = false;
}

export class Clinic {
    // instantiated with null values,
    // will be set only with what is read
    date: string = '';
    appointments: Array<Appointment> = [];
    billingAgent:string = '';
}

export class Patient {
    cr: string | null = '4';
    dateOfBirth: string | null = null;
    name: string | null = null;
    // referringPhysician: string | null = null;
    // dateOfRegistration: string | null = null;
    diseases: Array<any> = [];
    // sex: string = '';
    // OHIPnumber: string = ''; // 10 digits with 2 characters
}
export class RTPAppointment {
    cr: string = '4';
    date: string = (new Date).toISOString().split('T')[0];
    billingTime: string | null = null;
}


export class Physician {
    name: string = '';
    department: string = '';
    hospital: string = '';
    billingReportEmail: string = '';
    specialization: string = '';
    cpso: string = '';
    email: string = '';
}
export class Secretary {
    name: string = '';
    department: string = '';
    hospital: string = '';
    assignedPhysicians: string[] = [];
    physicians: string[] = []; // used in registration
}

// METHODS
/**
 * Checks to see if an appointment is valid
 * @param apt user generated Appointment
 * @returns {Object} Contains error message and whether the input is valid
 */
export function checkAppointment(apt: Appointment | any) {
    let errorMessage: string = '';
    for (let key in apt) {
        if (!apt[key] && !(key == 'hasReferral' || key == 'wasAssessedForHospitalAdmission' || key == 'userSubmittedCustomCodes' || key == 'billingTime')) {
            errorMessage += `You need to inclide patients ${key}.\n`
        }
    }
    return {
        errorMessage: errorMessage,
        success: !errorMessage
    };

}

export function checkPatient(patient: Patient | any) {
    let errorMessage: string = '';
    let valid: boolean = true;
    if (!patient.id) {
        errorMessage += 'id, '
    }
    if (!patient.dateOfBirth) {
        errorMessage += 'date of birth, '
    }
    if (!patient.sex) {
        errorMessage += 'sex, '
    }
    if (!patient.dateOfRegistration) {
        errorMessage += 'date of registration, '
    }
    if (!patient.referringPhysician) {
        errorMessage += 'referring physician, '
    }
    debugger
    if (errorMessage) {
        valid = false
        errorMessage = 'You must include ' + errorMessage + '\n';
    }
    const str = patient.OHIPnumber;
    let numberOfNumbers = 0;
    let numberOfCharacters = 0;
    for (let s: number = 0; s < str.length; s++) {
        if ((str[s] >= 'a' && str[s] <= 'z') || (str[s] >= 'A' && str[s] <= 'Z')) {
            numberOfCharacters++;
        } else if (str[s] >= '0' && str[s] <= '9') {
            numberOfNumbers++;
        } else {
            errorMessage += 'Invalid charcter in OHIP number!\n';
            valid = false;
        }
    }
    if (!(numberOfNumbers == 10 && numberOfCharacters == 2)) {
        errorMessage += 'OHIP number should be 10 numbers and 2 characters.\n';
    }
    if (errorMessage) {
        alert(errorMessage);
    }
    return valid;

}